/*
 * fn: getRecName
 *
 * Derives a Rec name from the card and partner names
 *
 */
import { type RecType } from '@/defs/rec'
import { getCardName } from '@/utils/cardUtil'

export const getRecName = (rec?: RecType) => getCardName(rec?.name, rec?.partnerRef?.name)
